export default __webpack_public_path__ + "media/music/46130a8b8952d1720a4b752e3398229f.mp3";